import React, { useState, useEffect } from "react";
import KeyboardArrowDownOutlinedIcon from "@mui/icons-material/KeyboardArrowDownOutlined";
import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import Chip from "@mui/material/Chip";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TablePagination from "@mui/material/TablePagination";
import TableRow from "@mui/material/TableRow";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import RefreshIcon from "@mui/icons-material/Refresh";
import dayjs from "dayjs";
import { formatWithTzLabel } from "../../utils/dateUtils";
import {
  Divider,
  Menu,
  TextField,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { MenuItem, Snackbar, Alert } from "@mui/material";
import { Select } from "@mui/material";
import { Grid } from "@mui/material";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import InputLabel from "@mui/material/InputLabel";
import FormControl from "@mui/material/FormControl";
import Tooltip from "@mui/material/Tooltip";
import InputAdornment from "@mui/material/InputAdornment";
import Search from "@mui/icons-material/Search";
import Typography from "@mui/material/Typography";
import DoDisturbIcon from "@mui/icons-material/DoDisturb";
import EditIcon from "@mui/icons-material/Edit";
import IconButton from "@mui/material/IconButton";
import AddOutlinedIcon from "@mui/icons-material/AddOutlined";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import WhatsappFormDialog from "./WhatsappFormDialog";
import { API_BASE_URL, TEMPLATE_ENDPOINT } from "../../config/urls";
import { useAuth } from "../../hooks/AuthProvider";
import { Add, Category, Language, Translate, Tune } from "@mui/icons-material";
import { FilterModal, FilterModalItem } from "../FilterModal";
import { CalendarIcon } from "@mui/x-date-pickers";
import TableFilterButton from "../TableFilterButton";
import TableSearchInput from "../TableSearchInput";
import ButtonOne from "../../common/normal-button";
import ButtonTwo from "../../common/dashboard-button";
import CampaignIcon from "@mui/icons-material/Campaign";
import SyncIcon from "@mui/icons-material/Sync";
import {
  borderColors,
  ColorsConstants,
  grayFontColor,
} from "../../cssUtils/constants";
import { FiberManualRecord as DotIcon } from "@mui/icons-material";
import CustomPagination from "../../common/custom-pagination";
import AppTable from "../../common/app-table";
import AppDropdown from "../../common/app-dropdown";
import AppDatePicker from "../../common/app-date-picker";
import CampaignTypeModal from "../CampaignManagement/CampaignTypeModal";
import typography from "../../cssUtils/typography";
import {
  FILTER_NAMESPACES,
  loadFilters,
  saveFilters,
  clearFilters,
} from "../../utils/filterStorage";

const FILTER_KEY = FILTER_NAMESPACES.WHATSAPP_TEMPLATES;
const DEFAULT_TEMPLATE_FILTERS = {
  language: "",
  category: "",
  status: "",
  dateRange: [null, null],
  appliedDateRange: [null, null],
};

export default function WhatsappTable({
  refreshKey,
  dateInput,
  setTemplatesNamesData,
  handleCreateTemplateClick,
  setComponent,
  setTemplatesData,
  templatesData,
  setTemplateData,
  templateData,
  ...props
}) {
  const { getValidToken } = useAuth();
  const [rowCount, setRowCount] = useState(0);
  const [languageList, setLanguageList] = useState([]);
  const [templatesModalState, settemplatesModalState] = useState({
    isOpen: false,
    selectedClient: null,
    mode: "add",
    jsonData: "",
  });
  const [controller, setController] = useState({
    page: 0,
    rowsPerPage: 20,
    serverSidePage: 0,
  });

  const [searchQuery, setSearchQuery] = useState("");
  const [searchTemplateId, setSearchTemplateId] = useState("");
  const [charCount, setCharCount] = useState(0);
  const [syncError, setSyncError] = useState("");

  const captilazeFirstLetter = (str) => {
    return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
  };

  // Consolidated filter state (persisted to localStorage)
  const [filters, setFilters] = useState(() => loadFilters(FILTER_KEY, DEFAULT_TEMPLATE_FILTERS));
  const {
    language: languageFilter,
    category: categoryFilter,
    status: statusFilter,
    dateRange,
    appliedDateRange,
  } = filters;
  const updateFilter = (field, value) => setFilters((prev) => ({ ...prev, [field]: value }));

  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const [dateAnchorEl, setDateAnchorEl] = useState(null);
  const [originalTemplatesData, setOriginalTemplatesData] = useState([]);
  const [toDate, setToDate] = useState(null);
  const [dateError, setDateError] = useState(null);
  const [campaignTypeModalOpen, setCampaignTypeModalOpen] = useState(false);
  const [campaignType, setCampaignType] = useState(null); // ["quick", "standard"]
  const [endDatePickerOpen, setEndDatePickerOpen] = useState(false);

  // Sync flag state
  const [syncFlag, setSyncFlag] = useState(false);

  const [filterModalOpen, setFilterModalOpen] = useState(false);

  // Action menu (3-dot) state
  const [actionMenuAnchor, setActionMenuAnchor] = useState(null);
  const [actionMenuTemplate, setActionMenuTemplate] = useState(null);

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  const fetchData = async (isSync = false) => {
    let searchDateURL = "";
    if (dateInput) {
      let dateString = dayjs(dateInput).format("YYYY-MM-DD");
      searchDateURL = `&search_date=${dateString}`;
    }

    // Check for date error
    if (dateError) {
      console.log("Date error:", dateError);
      return; // Exit if there's a date error
    }

    // Construct query parameters for server-side filtering and pagination
    const queryParams = new URLSearchParams({
      limit: controller.rowsPerPage.toString(),
      offset: (controller.serverSidePage * controller.rowsPerPage).toString(),
      search_query: searchQuery,
      language_filter: languageFilter,
      category_filter: categoryFilter,
      status_filter: statusFilter,
      from_date: dateRange[0] ? dayjs(dateRange[0]).format("YYYY-MM-DD") : "",
      to_date: dateRange[1] ? dayjs(dateRange[1]).format("YYYY-MM-DD") : "",
      sync: isSync.toString(),
      ordering: "-last_edited",
      // sort: most recently edited first, then newest created
    });

    const token = await getValidToken();

    const tenant = localStorage.getItem("tenant");

    try {
      const response = await fetch(
        `${TEMPLATE_ENDPOINT}?${queryParams}${searchDateURL}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
            "X-Tenant-Id": tenant,
          },
        },
      );
      if (!response.ok) {
        throw new Error("Failed to fetch data");
      }
      const jsonData = await response.json();

      console.log(jsonData);

      setTemplatesData(jsonData.results);
      setOriginalTemplatesData(jsonData.results);
      setTemplatesNamesData(jsonData.template_names);
      setLanguageList(jsonData.language_list);
      setRowCount(jsonData.count);

      // Reset sync flag after successful fetch
      if (isSync) setSyncFlag(false);
    } catch (error) {
      console.error("Error fetching data:", error.message);

      // Reset sync flag even on error
      if (isSync) setSyncFlag(false);
    }
  };

  const fetchSingleTemplateData = async (template) => {
    try {
      const token = await getValidToken();
      const tenant = localStorage.getItem("tenant");
      // SPM/MPM templates have no template_id until the product sync fills it in
      const query = template.template_id
        ? `template_id=${encodeURIComponent(template.template_id)}`
        : `template_name=${encodeURIComponent(template.template_name)}`;

      const response = await fetch(
        `${API_BASE_URL}/templates/sync-template-quality/?${query}`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
            "X-Tenant-Id": tenant,
          },
        },
      );

      const data = await response.json();

      if (!response.ok) {
        console.error("Sync failed:", data);
        setSyncError(data.error || "Template sync failed");
        return;
      }

      setTemplatesData((prev) =>
        prev.map((t) =>
          t.template_name === template.template_name
            ? {
                ...t,
                template_id: data.template_id || t.template_id,
                status: data.status,
                template_quality: data.template_quality,
              }
            : t,
        ),
      );
    } catch (error) {
      console.error("Error syncing template:", error);
      setSyncError("Template sync failed");
    }
  };

  function buildColumns({
    captilazeFirstLetter,
    handleViewClick,
    handleOpenCampaignTypeModal,
    setComponent,
    setTemplateData,
    handleDisableClick,
  }) {
    return [
      {
        id: "template_name",
        label: "Template Name",
        render: (template) => {
          const isInactive = template.active === false;
          if (isInactive) {
            return (
              <Tooltip title="This template has been disabled">
                <span style={{ color: "#9e9e9e" }}>
                  {template.template_name}
                </span>
              </Tooltip>
            );
          }
          return (
            <a
              href="#"
              onClick={(e) => {
                e.preventDefault();
                handleViewClick(template, e);
              }}
              style={{
                color: ColorsConstants.primaryBlue100,
                textDecoration: "none",
              }}
            >
              {template.template_name}
            </a>
          );
        },
      },
      {
        id: "category",
        label: "Category",
        render: (t) =>
          t.category === "MARKETING"
            ? "Marketing"
            : t.category === "UTILITY"
              ? "Utility"
              : t.category === "AUTHENTICATION"
                ? "Authentication"
                : "Unknown",
      },
      {
        id: "language",
        label: "Language",
        render: (t) => captilazeFirstLetter(t.language),
      },
      {
        id: "status",
        label: "Status",
        render: (template) => {
          const isInactive = template.active === false;

          if (isInactive) {
            return (
              <Chip
                variant="outlined"
                style={{ color: "#9e9e9e", borderColor: "#9e9e9e" }}
                label="INACTIVE"
                size="small"
              />
            );
          }

          const getChip = () => {
            if (template.status === "APPROVED")
              return (
                <Chip
                  variant="outlined"
                  color="success"
                  label="APPROVED"
                  size="small"
                />
              );

            if (template.status === "REJECTED")
              return (
                <Chip
                  variant="outlined"
                  color="primary"
                  label="REJECTED"
                  size="small"
                />
              );

            if (template.status === "FAILED")
              return (
                <Chip
                  variant="outlined"
                  color="warning"
                  label="FAILED"
                  size="small"
                />
              );

            return (
              <Chip
                variant="outlined"
                color="warning"
                label="PENDING"
                size="small"
              />
            );
          };

          return (
            <Box display="flex" alignItems="center" gap={1}>
              {getChip()}
              {template.status === "PENDING" && (
                <Tooltip title="Sync status">
                  <IconButton
                    size="small"
                    onClick={() => {
                      fetchSingleTemplateData(template);
                    }}
                  >
                    <SyncIcon fontSize="18" />
                  </IconButton>
                </Tooltip>
              )}
            </Box>
          );
        },
      },
      {
        id: "template_id",
        label: "Template ID",
        render: (t) =>
          t.event_id === "" || !t.event_id ? t.template_id : t.event_id,
      },
      {
        id: "template_quality",
        label: "Template Quality",
        render: (template) => {
          const q = template.template_quality;

          if (q === "UNKNOWN" || q === null) {
            if (["REJECTED", "FAILED"].includes(template.status)) return "";
            return (
              <Chip
                variant="outlined"
                color="success"
                size="small"
                label="Pending Quality"
              />
            );
          }

          const dotColor = {
            GREEN: "#10b981",
            YELLOW: "#f59e0b",
            RED: "#C40C0C",
          }[q];
          const textColor =
            { GREEN: "#059669", YELLOW: "#d97706", RED: "#C40C0C" }[q] ??
            "text.primary";

          return (
            <Box display="flex" alignItems="center" gap={1}>
              <DotIcon sx={{ fontSize: 8, color: dotColor }} />
              <Typography
                variant="body1"
                sx={{
                  fontWeight: 500,
                  color: textColor,
                  textTransform: "capitalize",
                }}
              >
                {q?.toLowerCase()}
              </Typography>
            </Box>
          );
        },
      },
      {
  id: "description",
  label: "Description",
  render: (t) => (
    <Tooltip title={t.description || ""} arrow>
      <Typography
        variant="body2"
        sx={{
          maxWidth: 250,
          overflow: "hidden",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap",
        }}
      >
        {t.description || "-"}
      </Typography>
    </Tooltip>
  ),
},
      {
        id: "created_at",
        label: "Created Date",
        render: (t) => new Date(t.created_at).toLocaleDateString("en-GB"),
      },
      {
        id: "updated_at",
        label: "Updated At",
        render: (t) => formatWithTzLabel(t.updated_at),
      },
      { id: "updated_by", label: "Updated By" },
      {
        id: "action",
        label: "Action",
        align: "center",
        minWidth: 150,
        render: (template) => {
          const isInactive = template.active === false;

          if (isInactive) {
            return (
              <Tooltip title="This template has been disabled">
                <span>
                  <IconButton disabled>
                    <EditIcon sx={{ fontSize: 18 }}/>
                  </IconButton>
                  <IconButton disabled style={{ marginLeft: 3 }}>
                    <DoDisturbIcon sx={{ fontSize: 18 }}/>
                  </IconButton>
                </span>
              </Tooltip>
            );
          }

          const editedTooRecently =
            dayjs().diff(dayjs(template.last_edited), "hour") < 24;
          const notEditable = !(
            template.status === "APPROVED" || template.status === "REJECTED"
          );
          const isDrip = template.is_drip_template;
          const isCarousel =
            template?.template_preview_json?.marketingOption === "carousel";
          const isAuthentication = template.category === "AUTHENTICATION";

          const editDisabled =
            editedTooRecently ||
            notEditable ||
            isDrip ||
            isCarousel ||
            isAuthentication;

          const editTooltip = editedTooRecently
            ? "Template cannot be edited within 24 hours of last edit"
            : notEditable
              ? "Only approved and rejected templates can be edited"
              : isDrip
                ? "Active Drip templates cannot be edited"
                : isCarousel
                  ? "Image and Video Carousel templates cannot be edited"
                  : isAuthentication
                    ? "Authentication templates cannot be edited. Create a new one instead."
                    : "Edit template";

          const isMenuOpen =
            Boolean(actionMenuAnchor) &&
            actionMenuTemplate?.template_id === template.template_id;

          const closeActionMenu = () => {
            setActionMenuAnchor(null);
            setActionMenuTemplate(null);
          };

          return (
            <>
              {/* 3-dot action trigger */}
              <IconButton
                onClick={(e) => {
                  setActionMenuAnchor(e.currentTarget);
                  setActionMenuTemplate(template);
                }}
                disableRipple
                sx={{
                  p: 0.5,
                  color: "#111827",
                  backgroundColor: "transparent",
                  "&:hover": { backgroundColor: "transparent", color: "#111827" },
                  "&:focus": { backgroundColor: "transparent" },
                  "&:active": { backgroundColor: "transparent" },
                }}
              >
                <MoreVertIcon sx={{ fontSize: 18 }} />
              </IconButton>

              <Menu
                anchorEl={actionMenuAnchor}
                open={isMenuOpen}
                onClose={closeActionMenu}
                anchorOrigin={{ vertical: "top", horizontal: "left" }}
                transformOrigin={{ vertical: "top", horizontal: "right" }}
                PaperProps={{
                  sx: {
                    p: 0.25,
                    "& .MuiList-root": { p: 0 },
                  },
                }}
              >
                <Box sx={{ display: "flex", flexDirection: "column", alignContent: "center", gap: 0, px: 0.5 }}>
                  {/* Campaign / Broadcast button — only for APPROVED templates */}
                  {template.status === "APPROVED" && (
                    <Tooltip title="Broadcast Template" arrow placement="top">
                      <span>
                        <IconButton
                          onClick={() =>
                            // handleCampaignClick(
                            //   template.template_name,
                            //   template.category,
                            //   template.template_id
                            // )
                            {
                              handleOpenCampaignTypeModal();
                              setTemplateData(template);
                              closeActionMenu();
                            }
                          }
                          sx={{ color: "#0F172A" }}
                        >
                          <CampaignIcon sx={{ fontSize: 18 }}/>
                        </IconButton>
                      </span>
                    </Tooltip>
                  )}

                  {/* Edit button */}
                  <Tooltip title={editTooltip} arrow placement="top">
                    <span>
                      <IconButton
                        onClick={() => {
                          setComponent(3);
                          setTemplateData(template);
                          closeActionMenu();
                        }}
                        sx={{ color: "#0F172A" }}
                        disabled={editDisabled}
                        style={{ pointerEvents: editDisabled ? "auto" : undefined }}
                      >
                        <EditIcon sx={{ fontSize: 18 }}/>
                      </IconButton>
                    </span>
                  </Tooltip>

                  {/* Disable button */}
                  <Tooltip
                    title={
                      isDrip
                        ? "Active Drip templates cannot be disabled"
                        : "Disable template"
                    }
                    arrow
                    placement="top"
                  >
                    <span>
                      <IconButton
                        onClick={() => {
                          handleDisableClick(template);
                          closeActionMenu();
                        }}
                        style={{ marginLeft: 3 }}
                        sx={{ color: "#0F172A" }}
                        disabled={isDrip}
                      >
                        <DoDisturbIcon sx={{ fontSize: 18 }} />
                      </IconButton>
                    </span>
                  </Tooltip>

                  <Tooltip
                    title={
                      "Sync template"
                    }
                    arrow
                    placement="top"
                  >
                    <span>
                      <IconButton
                        onClick={() => {
                          fetchSingleTemplateData(template);
                          closeActionMenu();
                        }}
                        style={{ marginLeft: 3 }}
                        sx={{ color: "#0F172A" }}
                      >
                        <SyncIcon sx={{ fontSize: 18 }} />
                      </IconButton>
                    </span>
                  </Tooltip>
                </Box>
              </Menu>
            </>
          );
        },
      },
    ];
  }

  useEffect(() => {
    // Check if any template is still pending
    const hasPending = templatesData.some((t) => t.status === "PENDING");

    if (!hasPending) return;

    const interval = setInterval(() => {
      fetchData(false); // normal fetch, no sync flag
    }, 30000); // 30 seconds

    return () => clearInterval(interval);
  }, [templatesData]);

  useEffect(() => {
    fetchData(syncFlag);
  }, [
    controller.serverSidePage,
    controller.rowsPerPage,
    refreshKey,
    searchQuery,
    languageFilter,
    categoryFilter,
    statusFilter,
    dateRange,
    syncFlag,
  ]);

  const handleOpenCampaignTypeModal = () => {
    setCampaignTypeModalOpen(true);
  };

  const handleCloseCampaignTypeModal = () => {
    setCampaignTypeModalOpen(false);
  };

  // Template list -> Campaigns setup with this template preselected (standard = new campaign, quick = single contact)
  const openCampaignSetup = (mode) => {
    props.onNavigate("campaigns_v2_setup", {
      mode,
      template: {
        templateName: templateData.template_name,
        templateCategory: templateData.category,
        templateId: templateData.template_id,
      },
    });
  };

  // pagination
  const handlePageChange = (event, newPage) => {
    setController((prev) => ({
      ...prev,
      page: newPage,
      serverSidePage: newPage, // Sync server-side page with UI page
    }));
  };

  const handleChangeRowsPerPage = (event) => {
    setController((prev) => ({
      // Fix: use prev parameter correctly
      ...prev,
      rowsPerPage: parseInt(event.target.value, 10),
      page: 0,
      serverSidePage: 0, // Reset to first page
    }));
  };

  const handleDateRangeApply = () => {
    updateFilter("appliedDateRange", dateRange);
    setDateAnchorEl(null);
    setController((prev) => ({ ...prev, page: 0 }));
  };

  const handleDateRangeCancel = () => {
    setFilters((prev) => ({ ...prev, dateRange: [null, null], appliedDateRange: [null, null] }));
    setDateAnchorEl(null);
    if (appliedDateRange[0] && appliedDateRange[1]) {
      setController((prev) => ({ ...prev, page: 0 }));
    }
  };

  // Search filter
  const handleSearchQueryChange = (event) => {
    if (event.target.value.length > 50) {
      return;
    }
    const value = event.target.value;
    setSearchQuery(event.target.value);
    setCharCount(value.length);
  };
  const handleSearchByTemplateIDChange = (event) => {
    if (event.target.value.length > 50) {
      return;
    }
    const value = event.target.value;
    setSearchTemplateId(event.target.value);
    setCharCount(value.length);
  };

  const handleDisableClick = (template) => {
    if (!template.active) return; // Prevent interactions with disabled templates
    settemplatesModalState({
      isOpen: true,
      selectedClient: template,
      mode: "disable",
    });
  };

  const handleViewClick = (template, e) => {
    if (!template.active) {
      e.preventDefault();
      return; // Prevent interactions with disabled templates
    }

    if (template.template_preview_json != "{}") {
      console.log("template json present");
      settemplatesModalState({
        isOpen: true,
        selectedClient: template,
        mode: "view",
        jsonData: template.template_preview_json,
      });
    } else {
      console.error("No JSON found for template");
    }
  };

  const handleLanguageFilterChange = (event) => {
    updateFilter("language", event.target.value);
  };

  const handleCategoryFilterChange = (event) => {
    updateFilter("category", event.target.value);
  };

  const handleFromDateChange = (newValue) => {
    if (toDate && newValue && dayjs(newValue).isAfter(toDate)) {
      setDateError("From Date must be less than or equal to To Date");
    } else {
      setDateError(null);
      updateFilter("dateRange", [newValue, dateRange[1]]);
    }
  };

  const handleDateClick = (event) => {
    setDateAnchorEl(event.currentTarget);
  };

  const handleDateClose = () => {
    setAnchorEl(null);
  };

  const handleApplyDate = () => {
    if (!dateRange[0] || !dateRange[1]) {
      setDateError("Both dates are required");
      return;
    }
    updateFilter("appliedDateRange", [dateRange[0], dateRange[1]]);
    setDateError(null);
    handleDateClose();
  };
  const handleToDateOpen = () => {
    if (!dateRange[0]) {
      setDateError("Please select From date");
      setEndDatePickerOpen(false);
    } else {
      setDateError(null);
      setEndDatePickerOpen(true);
    }
    setController((prev) => ({
      ...prev,
      page: 0,
      serverSidePage: 0, // Reset to first page
    }));
  };

  const handleToDateChange = (newValue) => {
    if (dateRange[0] && newValue && dayjs(newValue).isBefore(dateRange[0])) {
      setDateError("To Date must be greater than or equal to From Date");
    } else {
      setDateError(null);
      setToDate(newValue);
    }
  };

  const handleResetFilter = () => {
    setFilters({ ...DEFAULT_TEMPLATE_FILTERS });
    clearFilters(FILTER_KEY);
    setToDate(null);
    setSearchQuery("");
    setDateError(null);
    setController((prev) => ({ ...prev, page: 0, serverSidePage: 0 }));
  };

  const handleSync = async () => {
    setSyncFlag(true);
    setController((prev) => ({
      ...prev,
      page: 0,
      rowsPerPage: 20,
      serverSidePage: 0, // Reset server-side page as well
    }));
  };

  const getTotalActiveFilters = () => {
    let count = 0;
    if (languageFilter) count++;
    if (categoryFilter) count++;
    if (dateRange[0]) count++;
    if (dateRange[1]) count++;
    return count;
  };

  useEffect(() => {
    saveFilters(FILTER_KEY, filters);
  }, [filters]);

  const handleCampaignClick = (templateName, templateCategory, templateId) => {
    props.onNavigate("campaigns_v2_setup", { mode: "create", template: { templateName, templateCategory, templateId } });
  };

  const tableColumns = buildColumns({
    captilazeFirstLetter,
    handleViewClick,
    handleOpenCampaignTypeModal,
    setComponent,
    setTemplateData,
    handleDisableClick,
  });

  const rowSx = (template) =>
    template.active === false
      ? {
          backgroundColor: "#f5f5f5",
          opacity: 0.7,
          cursor: "not-allowed",
          "&:hover": { backgroundColor: "#f5f5f5" },
        }
      : {};

  useEffect(() => {
    if (!searchTemplateId) {
      setTemplatesData(originalTemplatesData);
      return;
    }

    const filtered = originalTemplatesData.filter((template) =>
      template.template_id
        ?.toLowerCase()
        .includes(searchTemplateId.toLowerCase()),
    );

    setTemplatesData(filtered);
  }, [searchTemplateId, originalTemplatesData]);

  return (
    <div>
      <Snackbar
        open={!!syncError}
        autoHideDuration={4000}
        onClose={() => setSyncError("")}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert severity="error" onClose={() => setSyncError("")}>
          {syncError}
        </Alert>
      </Snackbar>
      {isMobile && (
        <Box sx={{ mb: 2, display: "flex", flexDirection: "column", gap: 2 }}>
          <Box sx={{ display: "flex", justifyContent: "space-between" }}>
            <ButtonOne variant="contained" startIcon={<Add />} title="Create" />
          </Box>
          <Divider />
          <Box
            sx={{ display: "flex", justifyContent: "space-between", gap: 1 }}
          >
            <TableSearchInput
              searchQuery={searchQuery}
              onSearchChange={handleSearchQueryChange}
              charCount={charCount}
              // tooltip="Search by Template Name"
            />
            <TableFilterButton
              setFilterModalOpen={setFilterModalOpen}
              totalActiveFilters={getTotalActiveFilters()}
            />
          </Box>
        </Box>
      )}
      <Paper sx={{ width: "100%", overflow: "hidden" }}>
        {!isMobile && (
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <Paper sx={{ width: "100%", overflow: "hidden" }}>
              {!isMobile && (
                <Box
                  sx={{
                    p: 1,
                    bgcolor: "background.paper",
                    borderRadius: 1,
                    my: 2,
                    display: "flex",
                    flexWrap: "wrap",
                    gap: 1,
                  }}
                >
                  <Box>

                  <TableSearchInput
                    searchQuery={searchQuery}
                    onSearchChange={handleSearchQueryChange}
                    charCount={charCount}
                    // tooltip="Search by Template Name"
                    placeholder="Search by Template Name"
                  />
                  </Box>

                  <AppDropdown
                    endIcon={<KeyboardArrowDownOutlinedIcon />}
                    menuItems={[
                      { label: "Marketing", value: "MARKETING" },
                      { label: "Utility", value: "UTILITY" },
                      { label: "Authentication", value: "AUTHENTICATION" },
                    ]}
                    selectedValue={categoryFilter}
                    onMenuSelect={(value) =>
                      handleCategoryFilterChange({ target: { value } })
                    }
                  >
                    <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                      <span>
                        {categoryFilter
                          ? captilazeFirstLetter(categoryFilter)
                          : "Category"}
                      </span>
                      {categoryFilter && (
                        <Chip
                          label={captilazeFirstLetter(categoryFilter)}
                          size="small"
                          onDelete={() =>
                            handleCategoryFilterChange({
                              target: { value: "" },
                            })
                          }
                        />
                      )}
                    </Box>
                  </AppDropdown>

                  <AppDropdown
                    endIcon={<KeyboardArrowDownOutlinedIcon />}
                    menuItems={[...new Set(languageList)].map((lang) => ({
                      label: captilazeFirstLetter(lang),
                      value: lang,
                    }))}
                    selectedValue={languageFilter}
                    onMenuSelect={(value) =>
                      handleLanguageFilterChange({ target: { value } })
                    }
                  >
                    <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                      <span>
                        {languageFilter
                          ? captilazeFirstLetter(languageFilter)
                          : "Language"}
                      </span>
                      {languageFilter && (
                        <Chip
                          label={captilazeFirstLetter(languageFilter)}
                          size="small"
                          onDelete={() =>
                            handleLanguageFilterChange({
                              target: { value: "" },
                            })
                          }
                        />
                      )}
                    </Box>
                  </AppDropdown>

                  <AppDropdown
                    endIcon={<KeyboardArrowDownOutlinedIcon />}
                    menuItems={[
                      { label: "Approved", value: "APPROVED" },
                      { label: "Rejected", value: "REJECTED" },
                      { label: "Failed", value: "FAILED" },
                      { label: "Pending", value: "PENDING" },
                      { label: "Inactive", value: "INACTIVE" },
                    ]}
                    selectedValue={statusFilter}
                    onMenuSelect={(value) => updateFilter("status", value)}
                  >
                    <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                      <span>
                        {statusFilter
                          ? captilazeFirstLetter(statusFilter)
                          : "Status"}
                      </span>
                      {statusFilter && (
                        <Chip
                          label={captilazeFirstLetter(statusFilter)}
                          size="small"
                          onDelete={() => updateFilter("status", "")}
                        />
                      )}
                    </Box>
                  </AppDropdown>

                  <AppDropdown
                    endIcon={
                      <KeyboardArrowDownOutlinedIcon
                        sx={{ color: grayFontColor }}
                      />
                    }
                    paperProps={{
                      width: dateAnchorEl
                        ? dateAnchorEl.offsetWidth * 2
                        : undefined,
                      maxWidth: "500px",
                    }}
                    menuContent={(closeMenu) => (
                      <Box sx={{ p: 2 }}>
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                          <Box
                            sx={{
                              display: "flex",
                              flexDirection: "column",
                              gap: 2,
                            }}
                          >
                            <Typography sx={{ ...typography.bodyLarge }}>
                              Select date range:
                            </Typography>
                            <Box sx={{ display: "flex", gap: 2 }}>
                              <DatePicker
                                disableFuture
                                format="DD/MM/YYYY"
                                label="Created Date From"
                                value={dateRange[0]}
                                onChange={(newValue) =>
                                  updateFilter("dateRange", [newValue, dateRange[1]])
                                }
                                slotProps={{
                                  textField: {
                                    size: "small",
                                    sx: {
                                      width: "200px",
                                      "& .MuiInputBase-root": {
                                        height: "40px",
                                      },
                                    },
                                  },
                                }}
                              />
                              <DatePicker
                                disableFuture
                                format="DD/MM/YYYY"
                                label="Created Date To"
                                value={dateRange[1]}
                                onChange={(newValue) =>
                                  updateFilter("dateRange", [dateRange[0], newValue])
                                }
                                minDate={dateRange[0] || undefined}
                                open={endDatePickerOpen}
                                onOpen={handleToDateOpen}
                                onClose={() => setEndDatePickerOpen(false)}
                                slotProps={{
                                  textField: {
                                    error:
                                      (dateRange[1] && !dateRange[0]) ||
                                      dateError,
                                    helperText:
                                      dateRange[1] && !dateRange[0]
                                        ? "Please select Created Date From first"
                                        : dateError,
                                    size: "small",
                                    sx: {
                                      width: "200px",
                                      "& .MuiInputBase-root": {
                                        height: "40px",
                                      },
                                    },
                                  },
                                }}
                              />
                            </Box>
                            <Box
                              sx={{
                                display: "flex",
                                justifyContent: "flex-end",
                                gap: 1,
                              }}
                            >
                              <ButtonTwo
                                onClick={() => {
                                  handleDateRangeCancel();
                                  closeMenu();
                                }}
                                variant="outlined"
                              >
                                Cancel
                              </ButtonTwo>
                              <ButtonOne
                                onClick={() => {
                                  handleDateRangeApply();
                                  closeMenu();
                                }}
                                variant="contained"
                                disabled={!dateRange[0] || !dateRange[1]}
                              >
                                Apply
                              </ButtonOne>
                            </Box>
                          </Box>
                        </LocalizationProvider>
                      </Box>
                    )}
                  >
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        overflow: "hidden",
                      }}
                    >
                      <Box
                        component="span"
                        sx={{
                          mr:
                            appliedDateRange[0] && appliedDateRange[1] ? 1 : 0,
                          flexShrink: 0,
                        }}
                      >
                          {appliedDateRange[0] && appliedDateRange[1]
                            ? "Date Range:"
                            : "Created Date"}
                      </Box>
                      {appliedDateRange[0] && appliedDateRange[1] && (
                        <Chip
                          size="small"
                          onDelete={handleDateRangeCancel}
                          label={`${appliedDateRange[0].format("DD/MM/YYYY")} - ${appliedDateRange[1].format("DD/MM/YYYY")}`}
                          sx={{
                            maxWidth: { sm: 80, md: 200 },
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",
                          }}
                        />
                      )}
                    </Box>
                  </AppDropdown>

                  <ButtonTwo title="Reset" onClick={handleResetFilter} />
                </Box>
              )}
            </Paper>
          </LocalizationProvider>
        )}

        <AppTable
          columns={tableColumns}
          rows={templatesData}
          rowKey={(t, i) => t.template_id ?? i}
          emptyMessage="No match found"
          // maxHeight={520}
          rowSx={rowSx}
          paperSx={{ border: "none", boxShadow: "none" }}
          containerSx={{
            scrollbarWidth: "thin",
            scrollbarColor: "#C5CEDB #F3F6FB",
            "&::-webkit-scrollbar": { width: "8px" },
            "&::-webkit-scrollbar-track": { backgroundColor: "#F3F6FB", borderRadius: "8px" },
            "&::-webkit-scrollbar-thumb": { backgroundColor: "#C5CEDB", borderRadius: "8px" },
            "&::-webkit-scrollbar-thumb:hover": { backgroundColor: "#A8B4C7" },
          }}
          count={rowCount}
          page={controller.page}
          rowsPerPage={controller.rowsPerPage}
          onPageChange={handlePageChange}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
        <WhatsappFormDialog
          modalState={templatesModalState}
          handleModalState={settemplatesModalState}
          selectedClient={templatesModalState.selectedClient}
          onDisableSuccess={() => fetchData(false)}
        />
      </Paper>
      <FilterModal
        open={filterModalOpen}
        onClose={() => setFilterModalOpen(false)}
        onReset={handleResetFilter}
      >
        <FilterModalItem
          name="Language"
          data={[...new Set(languageList)]}
          value={languageFilter}
          icon={<Translate />}
          onChange={handleLanguageFilterChange}
        />
        <FilterModalItem
          name="Category"
          data={["marketing", "utility", "authentication"]}
          value={categoryFilter}
          icon={<Category />}
          onChange={handleCategoryFilterChange}
        />
        <FilterModalItem
          name="From Date"
          type="date"
          value={dateRange[0]}
          onChange={(newValue) => {
            updateFilter("dateRange", [newValue, dateRange[1]]);
            handleDateRangeApply();
          }}
          icon={<CalendarIcon />}
        />
        <FilterModalItem
          name="To Date"
          type="date"
          value={dateRange[1]}
          onChange={(newValue) => {
            updateFilter("dateRange", [dateRange[0], newValue]);
            handleDateRangeApply();
          }}
          icon={<CalendarIcon />}
        />
      </FilterModal>
      <CampaignTypeModal
        open={campaignTypeModalOpen}
        onClose={handleCloseCampaignTypeModal}
        campaignType={campaignType}
        setCampaignType={setCampaignType}
        onQuickSelect={() => {
          handleCloseCampaignTypeModal();
          openCampaignSetup("quick");
        }}
        onStandardSelect={() => {
          handleCloseCampaignTypeModal();
          openCampaignSetup("create");
        }}
        typography={typography}
      />

    </div>
  );
}